// src/hooks/useApi.js
import { useMemo, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Acessa a URL da API a partir do arquivo config.js
const apiUrl = window.APP_CONFIG?.Url_Api || 'http://default-url.com';

export const useApi = () => {
  const { setIsAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Cria a instância do Axios com useMemo para evitar recriação
  const api = useMemo(() => {
    return axios.create({
      baseURL: apiUrl,
    });
  }, []);

  // Configura os interceptores
  useEffect(() => {
    // Interceptor de requisição
    const requestInterceptor = api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Interceptor de resposta
    const responseInterceptor = api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response)
        {
            //Erro de autenticacao
            if (error.response.status === 401 || error.response.status === 403)
            {
                localStorage.removeItem('token');
                setIsAuthenticated(false);
                //navigate('/login');
            }
            // //Erro de bad request
            // if (error.response.status === 400)
            // {
            //     localStorage.removeItem('token');
            //     setIsAuthenticated(false);
            //     navigate('/login');
            // }
        }
        return Promise.reject(error);
      }
    );

    // Limpeza dos interceptores ao desmontar o hook
    return () => {
      api.interceptors.request.eject(requestInterceptor);
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [api, setIsAuthenticated, navigate]);

  // Função genérica para requisições GET
  const fetchData = async (endpoint, params = {}) => {
    try {
      const response = await api.get(endpoint, { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error(`Erro ao obter dados de ${endpoint}:`, {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
      } else if (error.request) {
        console.error(`Erro ao obter dados de ${endpoint} - Nenhuma resposta recebida:`, error.request);
      } else {
        console.error(`Erro ao configurar requisição para ${endpoint}:`, error.message);
      }
      throw error;
    }
  };
  

  // Função genérica para requisições POST
  const postData = async (endpoint, data) => {
    try {
      const response = await api.post(endpoint, data);
      return response.data;
    } catch (error) {
      console.error(`Erro ao enviar dados para ${endpoint}:`, error);
      throw error;
    }
  };

  // Função genérica para requisições PUT
  const putData = async (endpoint, data) => {
    try {
      const response = await api.put(endpoint, data);
      return response.data;
    } catch (error) {
      console.error(`Erro ao enviar dados para ${endpoint}:`, error);
      throw error;
    }
  };

  // Retorna as funções e a instância do Axios (caso necessário)
  return {
    fetchData,
    postData,
    putData,
    api, // Opcional: exportar a instância do Axios para requisições personalizadas
  };
};